import { render, staticRenderFns } from "./PlayerGameHistory.vue?vue&type=template&id=7387ff31&"
import script from "./PlayerGameHistory.vue?vue&type=script&lang=js&"
export * from "./PlayerGameHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports